import React, { Component } from 'react'

class Legend extends Component {
    static renderItem(item) {
        return (
            <div className="legend-item" key={`${item.name}--${item.color}`}>
                <div style={{ backgroundColor: item.color }} className="color">
                    {' '}
                </div>
                <div className="name"> {item.name} </div>
            </div>
        )
    }

    render() {
        const { items } = this.props
        return <div className="legend">{items.map(Legend.renderItem)}</div>
    }
}

export default Legend
